import { SelectInput, TextArea, TextInput } from "components/core";
import { useFormik } from "formik";
import { FC } from "react";
import { wrapClick } from "utils";
import * as Yup from "yup";
import moment from "moment";

type ExtraInfoFormProps = {
  handleNext: (values: any) => void;
  handlePrevious: () => void;
  initialValues: any;
  values: any;
  handleCancel: () => void;
  roleName?: any
}

export const ExtraInfoForm: FC<ExtraInfoFormProps> = ({
  initialValues,
  handleNext,
  handleCancel,
  handlePrevious,
}) => {
  const form = useFormik({
    initialValues,
    validationSchema: Yup.object({
      priority: Yup.string().oneOf(["Low", "Medium", "High", "Critical"]).required("Kindly indicate the order priority"),
      estimatedResolutionDate: Yup.string().test({
        message: "Kindly enter a valid date",
        test: (val) => {
          const isAfterToday = moment(val).isAfter(new Date())
          const isBefore12MonthsFromToday = moment(val).isBefore(moment().add(12, "months"))
          return isAfterToday && isBefore12MonthsFromToday
        }
      }),
      notes: Yup.string().max(1000, "Extra notes are too long")
    }),
    onSubmit: (values) => {
      handleNext(values);
    },
    onReset: () => {
      handleCancel?.();
    },
  });

  return (
    <form
      onSubmit={form.handleSubmit}
      className="flex-1 flex flex-col overflow-hidden"
    >
      <div className="space-y-6 divide-y divide-gray-200 p-6 flex-1 overflow-y-auto">
        <div>
          <span className="text-xs font-light">Appointment Information</span>
          <div className="grid grid-cols-3 gap-6 mt-2">
            <div className="">
              <TextInput
                id="estimatedResolutionDate"
                label="Appointment Date & Time"
                type="datetime-local"
                min={moment().format("YYYY-MM-DDTHH:mm")}
                max={moment().add(12, "months").format("YYYY-MM-DDTHH:mm")}
                placeholder="e.g. 06/03/1957 10:00"
                {...form}
              />
            </div>
            <div className="">
              <SelectInput
                id="priority"
                label="Priority"
                required={true}
                options={[
                  { label: "--- Select Priority ---", value: "" },
                  { label: "Low", value: "Low" },
                  { label: "Medium", value: "Medium" },
                  { label: "High", value: "High" },
                  { label: "Critical", value: "Critical" },
                ]}
                {...form}
              />
            </div>

            <div className="col-span-3">
              <TextArea
                id="notes"
                label="Additional Notes"
                placeholder="e.g. Any extra information..."
                rows={10}
                {...form}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-50 dark:bg-gray-800 px-4 py-3 sm:py-4 sm:px-6 sm:flex sm:flex-row-reverse border-t border-gray-200">
        <button
          type="submit"
          className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
        >
          Next
        </button>
        <button
          type="button"
          className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 dark:border-gray-600 shadow-sm px-4 py-2 bg-white dark:bg-gray-900 text-base font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 hover:dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          onClick={wrapClick(handlePrevious)}
        >
          Previous
        </button>
        <button
          type="button"
          className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 dark:border-gray-600 shadow-sm px-4 py-2 bg-white dark:bg-gray-900 text-base font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 hover:dark:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          onClick={wrapClick(form.resetForm)}
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default ExtraInfoForm;
